export default __webpack_public_path__ + "static/media/Android2.82bfcfbd.jpg";